import React from 'react';
import bi from 'shared/bi/bi';

import PaymentEvents from 'shared/components/payment-events/payment-events';

export default class PaymentsBiHandler extends React.Component {

  logPaymentSucceeded() {
    bi.logWidgetSystem('video.purchase.succeeded');
  }

  logSubscribeSucceeded() {
    bi.logWidgetSystem('channel.subscribe.succeeded');
  }

  logUnsubscribeSucceeded() {
    bi.logWidgetSystem('channel.unsubscribe.succeeded');
  }

  render() {
    return (
      <PaymentEvents onSale={this.logPaymentSucceeded}
                     onRent={this.logPaymentSucceeded}
                     onSubscription={this.logSubscribeSucceeded}
                     onSubscriptionCancel={this.logUnsubscribeSucceeded} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/payments/bi-handler.js